import React, { memo } from 'react';
import { useTranslation } from 'react-i18next'

import { ICategoryNavItem, toTourCategory, topCategories } from '../../../../store/global/tourCategories'
import { ITopToursCategory, AppStoreDispatchAction, EAppActionTypes, withAppStoreValue } from '../../../../store';

interface ICategoryNavAppStoreProps {
    dispatch: AppStoreDispatchAction
    selectedTopCategory: ITopToursCategory
}

// TODO: 2019-08-20 do we need onBack?
interface ICategoryNavProps {
    onBack?: () => void
}

// CategoryNav
const CategoryNav: React.FC<ICategoryNavProps & ICategoryNavAppStoreProps> = memo(({ dispatch, selectedTopCategory, onBack }) => {
    const { t } = useTranslation()

    const handleItemClick = (item: ICategoryNavItem) => (e?: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if (e) e.preventDefault();

        dispatch({ type: EAppActionTypes.SetFilter, filter: item.filter})
        dispatch({ type: EAppActionTypes.SetSelectedTopCategory, selectedTopCategory: toTourCategory(item)})
    }
    
    return (
        <nav className="page-header-part secound-nav">
            {onBack && <button className="cta cta-back fl m-tb5" onClick={onBack}>
                <img src="/images/icons/icon-back.png" alt="back" /> {t('Back')}
            </button>}
            <ul>
                {topCategories.map((item) => (
                    <li key={item.name}>
                        <a href="/" onClick={handleItemClick(item)} className={item.name === selectedTopCategory.name ? "active nav-item" : "nav-item"}>
                            <img src={item.icon} alt={t(item.name)} />
                            {t(item.name)}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    )
})

export default withAppStoreValue<ICategoryNavAppStoreProps, ICategoryNavProps>(CategoryNav, ['dispatch', 'categories.selectedTopCategory'])